/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibleFilter = exports.V1PeriodUnit = exports.TimeUnit = exports.SuspensionStatusEnum = exports.SuspensionStatus = exports.StructNullValue = exports.SortOrder = exports.SortDirection = exports.ReasonNotSuspendable = exports.PublicFilter = exports.ProvisioningStatus = exports.PlansArchivedFilter = exports.PeriodUnitEnumPeriodUnit = exports.PeriodUnitEnum = exports.PaymentStatusEnumPaymentStatus = exports.PaymentStatusEnum = exports.PausePeriodStatus = exports.OrdersPaymentStatus = exports.OrdersOrderType = exports.OrdersOrderStatus = exports.OrderTypeEnumOrderType = exports.OrderTypeEnum = exports.OrderStatusEnumOrderStatus = exports.OrderStatusEnum = exports.OrderSortBy = exports.OrderMethodEnum = exports.OrderMethod = exports.NotSuspendableReason = exports.CancellationReason = exports.CancellationInitiatorEnum = exports.CancellationInitiator = exports.CancellationEffectiveAt = exports.CancellationCause = exports.CancelAtEnum = exports.CancelAt = exports.ArchivedFilterEnumArchivedFilter = void 0;
var ArchivedFilterEnumArchivedFilter;
(function (ArchivedFilterEnumArchivedFilter) {
    ArchivedFilterEnumArchivedFilter["ACTIVE"] = "ACTIVE";
    ArchivedFilterEnumArchivedFilter["ARCHIVED"] = "ARCHIVED";
    ArchivedFilterEnumArchivedFilter["ARCHIVED_AND_ACTIVE"] = "ARCHIVED_AND_ACTIVE";
})(ArchivedFilterEnumArchivedFilter = exports.ArchivedFilterEnumArchivedFilter || (exports.ArchivedFilterEnumArchivedFilter = {}));
var CancelAt;
(function (CancelAt) {
    CancelAt["UNDEFINED"] = "UNDEFINED";
    CancelAt["IMMEDIATELY"] = "IMMEDIATELY";
    CancelAt["NEXT_PAYMENT_DATE"] = "NEXT_PAYMENT_DATE";
})(CancelAt = exports.CancelAt || (exports.CancelAt = {}));
var CancelAtEnum;
(function (CancelAtEnum) {
    CancelAtEnum["Immediately"] = "Immediately";
    CancelAtEnum["NextPaymentDate"] = "NextPaymentDate";
})(CancelAtEnum = exports.CancelAtEnum || (exports.CancelAtEnum = {}));
var CancellationCause;
(function (CancellationCause) {
    CancellationCause["UNDEFINED"] = "UNDEFINED";
    CancellationCause["OWNER_ACTION"] = "OWNER_ACTION";
    CancellationCause["MEMBER_ACTION"] = "MEMBER_ACTION";
    CancellationCause["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    CancellationCause["PAYMENT_SETUP_FAILURE"] = "PAYMENT_SETUP_FAILURE";
    CancellationCause["UNKNOWN"] = "UNKNOWN";
})(CancellationCause = exports.CancellationCause || (exports.CancellationCause = {}));
var CancellationEffectiveAt;
(function (CancellationEffectiveAt) {
    CancellationEffectiveAt["UNDEFINED"] = "UNDEFINED";
    CancellationEffectiveAt["IMMEDIATELY"] = "IMMEDIATELY";
    CancellationEffectiveAt["NEXT_PAYMENT_DATE"] = "NEXT_PAYMENT_DATE";
})(CancellationEffectiveAt = exports.CancellationEffectiveAt || (exports.CancellationEffectiveAt = {}));
var CancellationInitiator;
(function (CancellationInitiator) {
    CancellationInitiator["UNDEFINED"] = "UNDEFINED";
    CancellationInitiator["OWNER"] = "OWNER";
    CancellationInitiator["MEMBER"] = "MEMBER";
    CancellationInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
    CancellationInitiator["SETUP_FAILURE"] = "SETUP_FAILURE";
})(CancellationInitiator = exports.CancellationInitiator || (exports.CancellationInitiator = {}));
var CancellationInitiatorEnum;
(function (CancellationInitiatorEnum) {
    CancellationInitiatorEnum["Owner"] = "Owner";
    CancellationInitiatorEnum["Member"] = "Member";
    CancellationInitiatorEnum["PaymentFailure"] = "PaymentFailure";
    CancellationInitiatorEnum["SetupFailure"] = "SetupFailure";
    CancellationInitiatorEnum["Unknown"] = "Unknown";
})(CancellationInitiatorEnum = exports.CancellationInitiatorEnum || (exports.CancellationInitiatorEnum = {}));
var CancellationReason;
(function (CancellationReason) {
    CancellationReason["CANCELLATION_REASON_UNDEFINED"] = "CANCELLATION_REASON_UNDEFINED";
    CancellationReason["OWNER_CANCELED"] = "OWNER_CANCELED";
    CancellationReason["PAYMENT_PROVIDER_CANCELED"] = "PAYMENT_PROVIDER_CANCELED";
    CancellationReason["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    CancellationReason["MEMBER_CANCELED"] = "MEMBER_CANCELED";
})(CancellationReason = exports.CancellationReason || (exports.CancellationReason = {}));
var NotSuspendableReason;
(function (NotSuspendableReason) {
    NotSuspendableReason["UNDEFINED"] = "UNDEFINED";
    NotSuspendableReason["PENDING"] = "PENDING";
    NotSuspendableReason["TRIAL"] = "TRIAL";
    NotSuspendableReason["CANCELED"] = "CANCELED";
    NotSuspendableReason["EXPIRED"] = "EXPIRED";
    NotSuspendableReason["NOT_STARTED"] = "NOT_STARTED";
    NotSuspendableReason["ALREADY_SUSPENDED"] = "ALREADY_SUSPENDED";
    NotSuspendableReason["OLD_STRIPE"] = "OLD_STRIPE";
})(NotSuspendableReason = exports.NotSuspendableReason || (exports.NotSuspendableReason = {}));
var OrderMethod;
(function (OrderMethod) {
    OrderMethod["UNKNOWN"] = "UNKNOWN";
    OrderMethod["MOTO"] = "MOTO";
    OrderMethod["POS"] = "POS";
})(OrderMethod = exports.OrderMethod || (exports.OrderMethod = {}));
var OrderMethodEnum;
(function (OrderMethodEnum) {
    OrderMethodEnum["UNKNOWN"] = "UNKNOWN";
    OrderMethodEnum["MOTO"] = "MOTO";
    OrderMethodEnum["POS"] = "POS";
})(OrderMethodEnum = exports.OrderMethodEnum || (exports.OrderMethodEnum = {}));
var OrderSortBy;
(function (OrderSortBy) {
    OrderSortBy["ORDER_SORT_BY_UNDEFINED"] = "ORDER_SORT_BY_UNDEFINED";
    OrderSortBy["DATE_CREATED"] = "DATE_CREATED";
    OrderSortBy["EXPIRATION_DATE"] = "EXPIRATION_DATE";
})(OrderSortBy = exports.OrderSortBy || (exports.OrderSortBy = {}));
var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["Draft"] = "Draft";
    OrderStatusEnum["Pending"] = "Pending";
    OrderStatusEnum["Active"] = "Active";
    OrderStatusEnum["Suspended"] = "Suspended";
    OrderStatusEnum["Canceled"] = "Canceled";
    OrderStatusEnum["Expired"] = "Expired";
    OrderStatusEnum["PendingCancellation"] = "PendingCancellation";
})(OrderStatusEnum = exports.OrderStatusEnum || (exports.OrderStatusEnum = {}));
var OrderStatusEnumOrderStatus;
(function (OrderStatusEnumOrderStatus) {
    OrderStatusEnumOrderStatus["UNDEFINED"] = "UNDEFINED";
    OrderStatusEnumOrderStatus["DRAFT"] = "DRAFT";
    OrderStatusEnumOrderStatus["PENDING"] = "PENDING";
    OrderStatusEnumOrderStatus["ACTIVE"] = "ACTIVE";
    OrderStatusEnumOrderStatus["PAUSED"] = "PAUSED";
    OrderStatusEnumOrderStatus["ENDED"] = "ENDED";
    OrderStatusEnumOrderStatus["CANCELED"] = "CANCELED";
})(OrderStatusEnumOrderStatus = exports.OrderStatusEnumOrderStatus || (exports.OrderStatusEnumOrderStatus = {}));
var OrderTypeEnum;
(function (OrderTypeEnum) {
    OrderTypeEnum["Online"] = "Online";
    OrderTypeEnum["Offline"] = "Offline";
})(OrderTypeEnum = exports.OrderTypeEnum || (exports.OrderTypeEnum = {}));
var OrderTypeEnumOrderType;
(function (OrderTypeEnumOrderType) {
    OrderTypeEnumOrderType["UNDEFINED"] = "UNDEFINED";
    OrderTypeEnumOrderType["ONLINE"] = "ONLINE";
    OrderTypeEnumOrderType["OFFLINE"] = "OFFLINE";
})(OrderTypeEnumOrderType = exports.OrderTypeEnumOrderType || (exports.OrderTypeEnumOrderType = {}));
var OrdersOrderStatus;
(function (OrdersOrderStatus) {
    OrdersOrderStatus["ORDER_STATUS_UNDEFINED"] = "ORDER_STATUS_UNDEFINED";
    OrdersOrderStatus["PENDING"] = "PENDING";
    OrdersOrderStatus["ACTIVE"] = "ACTIVE";
    OrdersOrderStatus["CANCELED"] = "CANCELED";
    OrdersOrderStatus["EXPIRED"] = "EXPIRED";
    OrdersOrderStatus["PENDING_CANCELLATION"] = "PENDING_CANCELLATION";
    OrdersOrderStatus["SUSPENDED"] = "SUSPENDED";
})(OrdersOrderStatus = exports.OrdersOrderStatus || (exports.OrdersOrderStatus = {}));
var OrdersOrderType;
(function (OrdersOrderType) {
    OrdersOrderType["ORDER_TYPE_UNDEFINED"] = "ORDER_TYPE_UNDEFINED";
    OrdersOrderType["ONLINE"] = "ONLINE";
    OrdersOrderType["OFFLINE"] = "OFFLINE";
})(OrdersOrderType = exports.OrdersOrderType || (exports.OrdersOrderType = {}));
var OrdersPaymentStatus;
(function (OrdersPaymentStatus) {
    OrdersPaymentStatus["PAYMENT_STATUS_UNDEFINED"] = "PAYMENT_STATUS_UNDEFINED";
    OrdersPaymentStatus["PAID"] = "PAID";
    OrdersPaymentStatus["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    OrdersPaymentStatus["REFUNDED"] = "REFUNDED";
    OrdersPaymentStatus["FAILED"] = "FAILED";
    OrdersPaymentStatus["UNPAID"] = "UNPAID";
})(OrdersPaymentStatus = exports.OrdersPaymentStatus || (exports.OrdersPaymentStatus = {}));
var PausePeriodStatus;
(function (PausePeriodStatus) {
    PausePeriodStatus["UNDEFINED"] = "UNDEFINED";
    PausePeriodStatus["ACTIVE"] = "ACTIVE";
    PausePeriodStatus["ENDED"] = "ENDED";
})(PausePeriodStatus = exports.PausePeriodStatus || (exports.PausePeriodStatus = {}));
var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["Unpaid"] = "Unpaid";
    PaymentStatusEnum["Paid"] = "Paid";
    PaymentStatusEnum["Failed"] = "Failed";
    PaymentStatusEnum["Refunded"] = "Refunded";
    PaymentStatusEnum["Pending"] = "Pending";
    PaymentStatusEnum["NotApplicable"] = "NotApplicable";
})(PaymentStatusEnum = exports.PaymentStatusEnum || (exports.PaymentStatusEnum = {}));
var PaymentStatusEnumPaymentStatus;
(function (PaymentStatusEnumPaymentStatus) {
    PaymentStatusEnumPaymentStatus["UNDEFINED"] = "UNDEFINED";
    PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
    PaymentStatusEnumPaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatusEnumPaymentStatus["FAILED"] = "FAILED";
    PaymentStatusEnumPaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatusEnumPaymentStatus["PENDING"] = "PENDING";
    PaymentStatusEnumPaymentStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(PaymentStatusEnumPaymentStatus = exports.PaymentStatusEnumPaymentStatus || (exports.PaymentStatusEnumPaymentStatus = {}));
var PeriodUnitEnum;
(function (PeriodUnitEnum) {
    PeriodUnitEnum["Month"] = "Month";
    PeriodUnitEnum["Week"] = "Week";
    PeriodUnitEnum["Day"] = "Day";
    PeriodUnitEnum["Year"] = "Year";
})(PeriodUnitEnum = exports.PeriodUnitEnum || (exports.PeriodUnitEnum = {}));
var PeriodUnitEnumPeriodUnit;
(function (PeriodUnitEnumPeriodUnit) {
    PeriodUnitEnumPeriodUnit["UNDEFINED"] = "UNDEFINED";
    PeriodUnitEnumPeriodUnit["DAY"] = "DAY";
    PeriodUnitEnumPeriodUnit["WEEK"] = "WEEK";
    PeriodUnitEnumPeriodUnit["MONTH"] = "MONTH";
    PeriodUnitEnumPeriodUnit["YEAR"] = "YEAR";
})(PeriodUnitEnumPeriodUnit = exports.PeriodUnitEnumPeriodUnit || (exports.PeriodUnitEnumPeriodUnit = {}));
var PlansArchivedFilter;
(function (PlansArchivedFilter) {
    PlansArchivedFilter["ACTIVE"] = "ACTIVE";
    PlansArchivedFilter["ARCHIVED"] = "ARCHIVED";
    PlansArchivedFilter["ARCHIVED_AND_ACTIVE"] = "ARCHIVED_AND_ACTIVE";
})(PlansArchivedFilter = exports.PlansArchivedFilter || (exports.PlansArchivedFilter = {}));
var ProvisioningStatus;
(function (ProvisioningStatus) {
    ProvisioningStatus["NOT_STARTED"] = "NOT_STARTED";
    ProvisioningStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ProvisioningStatus["COMPLETED"] = "COMPLETED";
    ProvisioningStatus["FAILED"] = "FAILED";
})(ProvisioningStatus = exports.ProvisioningStatus || (exports.ProvisioningStatus = {}));
var PublicFilter;
(function (PublicFilter) {
    PublicFilter["PUBLIC_AND_HIDDEN"] = "PUBLIC_AND_HIDDEN";
    PublicFilter["PUBLIC"] = "PUBLIC";
    PublicFilter["HIDDEN"] = "HIDDEN";
})(PublicFilter = exports.PublicFilter || (exports.PublicFilter = {}));
var ReasonNotSuspendable;
(function (ReasonNotSuspendable) {
    ReasonNotSuspendable["UNDEFINED"] = "UNDEFINED";
    ReasonNotSuspendable["PENDING"] = "PENDING";
    ReasonNotSuspendable["TRIAL"] = "TRIAL";
    ReasonNotSuspendable["CANCELED"] = "CANCELED";
    ReasonNotSuspendable["ENDED"] = "ENDED";
    ReasonNotSuspendable["NOT_STARTED"] = "NOT_STARTED";
    ReasonNotSuspendable["ALREADY_SUSPENDED"] = "ALREADY_SUSPENDED";
    ReasonNotSuspendable["OLD_STRIPE"] = "OLD_STRIPE";
})(ReasonNotSuspendable = exports.ReasonNotSuspendable || (exports.ReasonNotSuspendable = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var StructNullValue;
(function (StructNullValue) {
    StructNullValue["NULL_VALUE"] = "NULL_VALUE";
})(StructNullValue = exports.StructNullValue || (exports.StructNullValue = {}));
var SuspensionStatus;
(function (SuspensionStatus) {
    SuspensionStatus["UNDEFINED"] = "UNDEFINED";
    SuspensionStatus["ACTIVE"] = "ACTIVE";
    SuspensionStatus["ENDED"] = "ENDED";
})(SuspensionStatus = exports.SuspensionStatus || (exports.SuspensionStatus = {}));
var SuspensionStatusEnum;
(function (SuspensionStatusEnum) {
    SuspensionStatusEnum["Active"] = "Active";
    SuspensionStatusEnum["Ended"] = "Ended";
})(SuspensionStatusEnum = exports.SuspensionStatusEnum || (exports.SuspensionStatusEnum = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Day"] = "Day";
    TimeUnit["Week"] = "Week";
    TimeUnit["Month"] = "Month";
    TimeUnit["Year"] = "Year";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var V1PeriodUnit;
(function (V1PeriodUnit) {
    V1PeriodUnit["MONTH"] = "MONTH";
    V1PeriodUnit["DAY"] = "DAY";
    V1PeriodUnit["WEEK"] = "WEEK";
    V1PeriodUnit["YEAR"] = "YEAR";
})(V1PeriodUnit = exports.V1PeriodUnit || (exports.V1PeriodUnit = {}));
var VisibleFilter;
(function (VisibleFilter) {
    VisibleFilter["VISIBLE_AND_HIDDEN"] = "VISIBLE_AND_HIDDEN";
    VisibleFilter["VISIBLE"] = "VISIBLE";
    VisibleFilter["HIDDEN"] = "HIDDEN";
})(VisibleFilter = exports.VisibleFilter || (exports.VisibleFilter = {}));
//# sourceMappingURL=types.js.map